var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEvent48Line = function SvgIconEvent48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 11.63h-1.2V10h-3.4v1.63h-9.6V10h-3.4v1.63h-1.2a5.31 5.31 0 0 0-5.3 5.3v15.4a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3v-15.4a5.31 5.31 0 0 0-5.3-5.3Zm-18.8 3.4h1.2v2h3.4v-2h9.6v2h3.4v-2h1.2a1.91 1.91 0 0 1 1.9 1.9v1.57H12.7v-1.58a1.9 1.9 0 0 1 1.9-1.89Zm18.8 19.2H14.6a1.9 1.9 0 0 1-1.9-1.9V21.91h22.65v10.42a1.91 1.91 0 0 1-1.95 1.9Z",
    fill: "current"
  })));
};
export default SvgIconEvent48Line;